import { Filter } from '@anytag/shared-molecules';
import { Template } from './Template';
import { usePackagesFilter } from './hooks';

export const PackagesFilter = () => {
  const { filter, setFilterForm } = usePackagesFilter();

  return (
    <Filter.Provider onSubmit={setFilterForm} values={filter}>
      <Template />
    </Filter.Provider>
  );
};

export { usePackagesFilter };
export * from './schemaTypes';
